/**
 * @param thenable jQuery Thenable
 * @returns {Promise<T>}
 */
export function aPromise<T = any>(thenable: JQuery.Thenable<T>) {
    return new Promise<T>((resolve, reject) => thenable.then(resolve, reject));
}